import "./style/css/LandingPage_css.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { SubscriptionAlert } from "./components/SubscriptionAlert";
import AppointmentBooking from "./components/ProfessionalSchedulePage/AppointmentBooking";
import LoginPage from "./LoginForm";
import PrivateRoute from "./PrivateRoute";
import { useAuth } from "./AuthContext";
import NotificationSettings from "./components/NotificationSettings";
import AppointmentDetail from "./components/AppointmentDetail";
import PatientDetail from "./components/PatientDetail";
import ProfessionalDashboard from "./components/ProfessionalDashboard";
import PatientsPage from "./components/PatientsPage";
import MonthlyStats from "./components/MonthlyStats";
import PatientForm from "./components/PatientForm";
import UserProfileComponent from "./components/UserProfileComponent";
import ServicesManager from "./components/ServicesManager";
import RegisteredAppointmentsTableAppointmentsPage from "./components/AppointmentsPage";
import OfficesManager from "./components/OfficesManager";
import OfficeDetail from "./components/OfficeDetail";
import ScheduleForm from "./components/ScheduleForm";
import WriteUs from "./components/WriteUs";
import ServiceTypeForm from "./components/ServiceTypeForm";
import LandingPage from "./components/LandingPage";
import NotFoundPage from "./components/NotFoundPage";
import AgendaPage from "./components/AgendaPage";
import AppHeader from "./components/AppHeader";
import RegisterForm from "./components/RegisterForm";
import RegistrationSuccess from "./components/RegistrationSuccess";
import AppointmentForm from "./components/AppointmentForm";
import ServiceForm from "./components/ServiceForm";
import OfficeForm from "./components/OfficeForm";
import EditProfile from "./components/EditProfile";
import ProfessionalsList from "./components/ProfessionalsList";

const AppRouter = () => {
  const { user } = useAuth();
  return (
    <div className="landing_page_wrapper">
      {user && <AppHeader />}
      {user && <SubscriptionAlert />}
      <Routes>
        <Route
          path="/login"
          element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />}
        />
        <Route
          path="/register"
          element={
            user ? <Navigate to="/dashboard" replace /> : <RegisterForm />
          }
        />
        <Route
          path="/registration-success"
          element={
            user ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <RegistrationSuccess />
            )
          }
        />
        <Route path="/:username" element={<AppointmentBooking />} />
        <Route
          path="/"
          element={
            user ? (
              <PrivateRoute>
                <AgendaPage />
              </PrivateRoute>
            ) : (
              <LandingPage />
            )
          }
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <AgendaPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <ProfessionalsList />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <UserProfileComponent />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile/telegram_bot"
          element={
            <PrivateRoute>
              <NotificationSettings />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile/edit"
          element={
            <PrivateRoute>
              <EditProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/patients"
          element={
            <PrivateRoute>
              <PatientsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/patient/:id"
          element={
            <PrivateRoute>
              <PatientDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/patient/edit/:id"
          element={
            <PrivateRoute>
              <PatientForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/patient/new"
          element={
            <PrivateRoute>
              <PatientForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/stats/"
          element={
            <PrivateRoute>
              <ProfessionalDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/monthly-stats"
          element={
            <PrivateRoute>
              <MonthlyStats />
            </PrivateRoute>
          }
        />
        <Route
          path="/appointments"
          element={
            <PrivateRoute>
              <RegisteredAppointmentsTableAppointmentsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/appointments/:id"
          element={
            <PrivateRoute>
              <AppointmentDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/appointment/edit/:id"
          element={
            <PrivateRoute>
              <AppointmentForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/appointment/new"
          element={
            <PrivateRoute>
              <AppointmentForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/appointments/user/:userId"
          element={
            <PrivateRoute>
              <RegisteredAppointmentsTableAppointmentsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/offices"
          element={
            <PrivateRoute>
              <OfficesManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/office/new"
          element={
            <PrivateRoute>
              <OfficeForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/office/:id"
          element={
            <PrivateRoute>
              <OfficeDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/offices/:id/edit"
          element={
            <PrivateRoute>
              <OfficeForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/offices/availability"
          element={
            <PrivateRoute>
              <ScheduleForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/offices/availability/:id"
          element={
            <PrivateRoute>
              <ScheduleForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/services"
          element={
            <PrivateRoute>
              <ServicesManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/service/new"
          element={
            <PrivateRoute>
              <ServiceForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/service/:id"
          element={
            <PrivateRoute>
              <ServiceForm />
            </PrivateRoute>
          }
        />

        <Route
          path="/service-types/:id"
          element={
            <PrivateRoute>
              <ServiceTypeForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/service-types/new"
          element={
            <PrivateRoute>
              <ServiceTypeForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/write-us"
          element={
            <PrivateRoute>
              <WriteUs />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};

export default AppRouter;
